import React, { useRef } from 'react';

interface TaskStatusSelectorProps {
    status: number;
    onChange: (value: string) => void;
}

const TaskStatusSelector: React.FC<TaskStatusSelectorProps> = ({
    status,
    onChange,
}) => {


    const getStatusColor = (status: number) => {
        switch (status) {
            case 1:
                return 'gray';
            case 2:
                return 'blue';
            case 3:
                return 'green';
            default:
                return 'gray';
        }
    };

    const indicatorDotStyles = {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        marginRight: '8px',
        backgroundColor: getStatusColor(status),
    };

    const selectStyles = {
        width: '100%',
        border: 'none',
        padding: '8px',
        outline: 'none',
        cursor: 'pointer',
        background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23${getStatusColor(
            status
        ).substring(
            1
        )}'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E") no-repeat right 8px center`, // Agrega una imagen (flecha) al lado derecho

        paddingRight: '24px',
    };

    return (
        <div className='d-flex align-items-center w-100'>
            <div
                className='indicator-dot me-2 rounded-circle'
                style={indicatorDotStyles}
            ></div>
            <div className='flex-grow-1'>
                <select
                    style={selectStyles}
                    className='form-select form-select-sm'
                    defaultValue={status.toString()}
                    onChange={(e) => onChange(e.target.value)}
                >
                    <option value='1'>Pendiente</option>
                    <option value='2'>En progreso</option>
                    <option value='3'>Terminado</option>
                </select>
            </div>
        </div>
    );
};

export default TaskStatusSelector;
